import { render, staticRenderFns } from "./IButton.vue?vue&type=template&id=06750f58&scoped=true&"
import script from "./IButton.vue?vue&type=script&lang=js&"
export * from "./IButton.vue?vue&type=script&lang=js&"
import style0 from "./IButton.vue?vue&type=style&index=0&id=06750f58&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06750f58",
  null
  
)

export default component.exports